import Subscription from "../models/subscription";

export default class SubscriptionContextModel {
  public subscriptions: Subscription[] = [];
  public subscription: Subscription = new Subscription();
}
